import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AlumniOrganizationJoinRibbon from './ribbon'
import AlumniOrganizationJoinDetail from './detail'

export default function AlumniOrganizationJoinAppointment() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [appointmentData, setAppointmentData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const initialConditions = {
      status: 0
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getAppointmentData = () => {
    axios.post('/p/alumni/organization_member_application/list/get', { 
      merchant_oid: merchantOid,
      status: filterValue.status,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAppointmentData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'appointments': response.data.appointments
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAppointmentData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 2) return 'green'
    if (key === 3) return 'red'
    return 'black'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">组织加入申请</div>
          <AlumniOrganizationJoinRibbon 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>申请人</th>
                <th>申请加入的组织</th>
                <th>审核状态</th>
                <th>申请时间</th>
              </tr>
            </thead>

            <tbody>
              {appointmentData.appointments && (appointmentData.appointments.length > 0 ? (appointmentData.appointments.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  {item.alumni_photo_url ?  
                    <td style={{textAlign: 'left', padding: '5px 0 5px 20px', display: 'flex', alignItems: 'center'}}>
                      <img style={{height: '50px', marginRight: '10px'}} src={item.alumni_photo_url} alt="" />
                      {item.alumni_name}
                    </td> : <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.alumni_name}</td>
                  }
                  <td>{item.organization_name}</td>
                  <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td>
                  <td>{item.create_time}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="4"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={appointmentData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <AlumniOrganizationJoinDetail
          data={propsData}
          isOpen={isDetailVisible}
          getAppointmentData={getAppointmentData}
          isCancel={() => { setIsDetailVisible(false) }}
        />}
      </div>
    </div>
  )
}
